import { useUser } from "@/hooks/useUser";

// An internal user viewing another org's estimate reads its chats read-only. Nothing streams to them,
// so they poll to see turns as they're saved.
export const INTERNAL_VIEW_POLL_MS = 5_000;

/** Whether the estimate's org isn't the user's own, which only an internal user can open. */
export function useIsInternalChatView(organizationId: string | undefined): boolean {
  const { currentUser } = useUser();
  return !!organizationId && organizationId !== currentUser?.organizationId;
}
